import builder from '../builder';
import ImageFileLandscapeAlternate from '../../streamline-icons/bold/image-file-landscape-alternate.svg';

export default builder(
  'ImageFileLandscapeAlternateBold',
  ImageFileLandscapeAlternate,
);
